export default {
  name: "gender",
  in: "query",
  required: false,
  description: "Filtration based on id of [gender](#model-gender) object",
  schema: {
    type: "integer",
    example: 1
  }
};
